import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ADMIN_ROLE, OWNER_ROLE } from "utils/constants";
import { StyledIntegrationErrorBanner } from "./style";
import { useHistory, useLocation } from "react-router-dom";

const CONNECTION_ERROR =
  "Xero Integration has disconnected or stopped working.";

const IntegrationErrorBanner = ({ errors, closeBanner }) => {
  const [showBanner, setShowBanner] = useState(false);

  const accountRole = useSelector((state) =>
    state.getIn(["headers", "accountRole"]),
  );

  const xeroSettingsConfigured = useSelector((state) =>
    state.getIn(["manageAccount", "xeroSettingsConfigured"]),
  );

  const location = useLocation();
  const history = useHistory();

  const handleRedirectManageAccount = () => {
    history.push("/manage-account/xero-settings");
  };

  const handleRedirectXeroDisconnected = () => {
    history.push("/manage-account/integration-error?error=XERO_DISCONNECTED");
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const fromOauth = searchParams.get("oauth") === "success";

    if (fromOauth) {
      setShowBanner(false);
      return;
    }

    const currentPath = window.location.pathname;
    const isIntegrationErrorPage = currentPath.includes(
      "/manage-account/integration-error",
    );

    if (isIntegrationErrorPage) {
      setShowBanner(false);
      return;
    }

    setShowBanner(true);
  }, [location.search]);

  if (!showBanner) {
    return null;
  }

  return (
    <>
      {errors.map((error) => {
        let messageAction = (
          <>
            Please check settings in{" "}
            <span className="link" onClick={handleRedirectManageAccount}>
              Manage Account
            </span>
          </>
        );

        if (error === CONNECTION_ERROR) {
          messageAction = (
            <>
              Please{" "}
              <span className="link" onClick={handleRedirectXeroDisconnected}>
                reconnect
              </span>{" "}
              to Xero.
            </>
          );
        }

        return (
          <StyledIntegrationErrorBanner key={error}>
            <div className="banner-content">
              <div className="img_icon" />
              <div className="message">
                {!xeroSettingsConfigured && error !== CONNECTION_ERROR
                  ? "Xero integration is not fully configured."
                  : error}{" "}
                {[OWNER_ROLE, ADMIN_ROLE].includes(accountRole)
                  ? messageAction
                  : "Please contact your account admin."}
              </div>
            </div>

            <div className="close_icon" onClick={closeBanner} />
          </StyledIntegrationErrorBanner>
        );
      })}
    </>
  );
};

export default IntegrationErrorBanner;
